<h2 *ngIf="authorized">Welcome to BUI.</h2>
<h2 *ngIf="!authorized">You are not authorized to access that page.</h2>
<div fxLayout.xs="column" fxLayoutGap="10px" fxLayoutAlign="center">
  <button mat-raised-button color="primary"
    [routerLink]="['/health']"
    [queryParams]="{ status: 'false' }"
    *ngIf="authorizedFor(healthRole)">Health
  </button>
  <button mat-raised-button color="primary"
    [routerLink]="['/life']"
    [queryParams]="{ status: 'true' }"
    *ngIf="authorizedFor(lifeRole)">Life
  </button>
  <button mat-raised-button color="primary"
    [routerLink]="['/fnol']"
    [queryParams]="{ status: 'false' }"
    *ngIf="authorizedFor(fnolRole)">FNOL
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/claims']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(claimsRole)">Claims
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/hr']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(hrRole)">HR
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/pnc']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(pncRole)">PNC
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/insidesales']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(insidesalesRole)">Inside Sales
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/it']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(itRole)">IT
  </button>
  <button mat-raised-button color="primary"
  [routerLink]="['/aacc']"
  [queryParams]="{ status: 'false' }"
  *ngIf="authorizedFor(aaccRole)">AACC
  </button>
</div>
